import { Toaster } from 'react-hot-toast';
import {
	About,
	Contact,
	Experience,
	Feedbacks,
	Hero,
	Navbar,
	Tech,
	Works,
	GitHubContributions,
	CommandPalette,
	Footer,
} from './components';

const App = () => {
	return (
		<div className="relative z-0 bg-warm">
			<a href="#about" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-4 focus:left-4 focus:bg-accent focus:text-white focus:px-4 focus:py-2 focus:rounded-lg">
				Skip to main content
			</a>
			<Toaster
				position="top-right"
				toastOptions={{
					duration: 5000,
					style: {
						background: '#1C1C1A',
						color: '#FAF8F5',
						border: '1px solid #E3DED6',
					},
					success: {
						iconTheme: { primary: '#4A6741', secondary: '#FAF8F5' },
					},
					error: {
						iconTheme: { primary: '#B45454', secondary: '#FAF8F5' },
					},
				}}
			/>
			<CommandPalette />
			<Navbar />
			<Hero />
			<div className="border-t border-border">
				<About />
			</div>
			<div className="bg-surface border-t border-border">
				<Works />
			</div>
			<div className="border-t border-border">
				<Tech />
			</div>
			<div className="bg-surface border-t border-border">
				<Experience />
			</div>
			<div className="border-t border-border">
				<Feedbacks />
			</div>
			<div className="bg-surface border-t border-border">
				<GitHubContributions />
			</div>
			<div className="border-t border-border">
				<Contact />
			</div>
			<Footer />
		</div>
	);
};

export default App;
